/* Mint-LaborContract · tab Phát hành. Màu chỉ var(--…). */
.grid { display: grid; grid-template-columns: minmax(0, 1fr) 560px; gap: 14px; align-items: start; }
.col { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.h { margin: 0; font-size: 16px; font-weight: 600; }
.sub { color: var(--tx2); }
.empRow { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 12px; margin-top: 10px; align-items: end; }
.chips { display: flex; flex-wrap: wrap; gap: 6px; }
.lab { display: block; min-width: 0; }
.lab > div:first-child { font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); margin-bottom: 6px; }
.ctl { box-sizing: border-box; width: 100%; height: 40px; padding: 0 12px; border-radius: 10px; border: 1px solid var(--bd); background: var(--card); color: var(--tx); font: inherit; }
.ctl:focus-visible, .tpl:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.lock { display: flex; align-items: center; gap: 6px; background: var(--sub); overflow: hidden; white-space: nowrap; }
.mask { color: var(--lb); }
.cards { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-top: 10px; }
.tpl { text-align: left; padding: 12px 14px; border: 0; border-radius: 12px; background: var(--sub); color: var(--tx); font: inherit; cursor: pointer; display: flex; flex-direction: column; gap: 4px; }
.tplOn { background: var(--pri-bg); box-shadow: inset 0 0 0 1.5px var(--pri); }
.tplOff { opacity: 0.55; }
.tplHd { display: flex; justify-content: space-between; gap: 8px; }
.tplHd b { font-weight: var(--fw-label); }
.gate { font-size: 12px; }
.gOk { color: var(--ok); }
.gWarn { color: var(--warn); }
.gErr { color: var(--err); }
.fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 14px; margin-top: 10px; }
.alert { margin-top: 12px; padding: 10px 12px; border-radius: 10px; font-size: 12px; font-weight: var(--fw-label); }
.aWarn { background: var(--warn-bg); color: var(--warn); }
.aErr { background: var(--err-bg); color: var(--err); }
.side { position: sticky; top: 14px; display: flex; flex-direction: column; gap: 10px; }
.pvHd { display: flex; justify-content: space-between; align-items: baseline; }
.pvHd > span { font-size: 12px; }
.paper { padding: 18px 20px; border-radius: 12px; border: 1px solid var(--bd); background: var(--card); font-size: 12px; line-height: 1.6; display: flex; flex-direction: column; gap: 4px; max-height: 560px; overflow-y: auto; }
.ctr { text-align: center; }
.pvTitle { font-size: 15px; font-weight: 600; margin-top: 8px; }
.l0 { margin-top: 10px; }
.hl { padding: 0 3px; border-radius: 4px; background: var(--pri-bg); color: var(--link); font-weight: 600; }
.miss { padding: 0 3px; border-radius: 4px; background: var(--err-bg); color: var(--err); font-weight: 600; }
.acts { display: flex; gap: 8px; justify-content: flex-end; }
